import { render, staticRenderFns } from "./DuplicateReceipt.vue?vue&type=template&id=66d50c44&scoped=true&"
import script from "./DuplicateReceipt.vue?vue&type=script&lang=js&"
export * from "./DuplicateReceipt.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateReceipt.vue?vue&type=style&index=0&id=66d50c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d50c44",
  null
  
)

export default component.exports